import { environment } from '@env/environment';
export interface TaskCompletionParams {
  name: string;
  description: string;
  required: boolean;
}

export class Const {
  // Formato(momentJs) para las fechas
  static readonly DATE_FMT = 'DD/MM/YYYY hh:mm:ss a';
  // Define si es integracion de cita 2
  static readonly INTEGRACION_CITA = environment.integrationCita;
  // Estados del tramite
  static readonly STATUS_TRAMITE = {
    active: 'En trámite',
    finished: 'Vigente',
    inactive: 'inactivo'
  };
  // Estados de las actividades
  static readonly STATUS_ACTIVITY = {
    // active: 'activo',
    inactive: 'inactivo',
    pending: 'pendiente',
    finished: 'finalizado'
  };
  // Estados de las tareas
  static readonly STATUS_TASK = {
    // active: 'activo',
    finished: 'finalizado',
    pending: 'pendiente',
    secondaryProgress: 'secundaria_progreso'
  };
  // Clases de los estados para las actividades y tareas
  static readonly CSS_STATUS = {
    finished: {
      class: 'green-box',
      color: '#28a745',
      icon: 'fa-check-circle'
    },
    pending: {
      class: 'blue-300-box',
      color: '#1130fe',
      icon: 'fa-hand-pointer-o'
    },
    inactive: {
      class: 'red-box',
      color: '#dc3545',
      icon: 'fa-times-circle'
    },
    secondaryProgress: {
      class: 'red-box',
      color: '#dc3545',
      icon: 'fa-lock'
    }
  };
  // Configuración para los paginadores
  static readonly PAGINATION = {
    itemsPerPage: 10,
    maxSize: 5,
    previousText: '&lsaquo;',
    nextText: '&rsaquo;',
    firstText: '&laquo;',
    lastText: '&raquo;'
  };
  // Tipos de las tareas
  static readonly TYPES_TASK = {
    none: 'ninguno',
    condition: 'condicion',
    microProcess: 'microproceso',
    assignment: 'asignacion',
    form: 'forma',
    secondary: 'secundaria'
  };
  // Parametros validos para la finalización
  static readonly TASK_COMPLETION_PARAMS: TaskCompletionParams[] = [
    {
      name: 'finalizacion',
      description: 'Finalizar tarea',
      required: true
    },
    {
      name: 'enviar_asignacion',
      description: 'Enviar asignación',
      required: false
    },
    {
      name: 'reiniciar_microproceso',
      description: 'Reiniciar microproceso',
      required: false
    },
    {
      name: 'reiniciar_microproceso_enviando_asignacion',
      description: 'Reiniciar microproceso enviando a asignación',
      required: false
    },
    {
      name: 'auto_asignar',
      description: 'Auto asignar responsable',
      required: false
    },
    {
      name: 'reactivar_tareas',
      description: 'Reactivar tareas',
      required: false
    },
    {
      name: 'asignar_responsable_asignacion',
      description: 'Asignación de responsable para asignación',
      required: false
    },
  ];
  // Key con la que se almacena en LocalStorage
  // un flujo usado en el módulo de automatización de procesos.
  static readonly KEY_LS_DEFAULT_FLOWS = {
    process: 'default-flows',
    secondaryProcess: 'default-secondary-flows'
  };
  // Rutas de integraciones en el sistema
  static readonly ROUTES_SYSTEM_INTEGRATIONS = {
    cita: {
      // tslint:disable-next-line: max-line-length
      index: environment.servers_integrations.CITA.SERVER + environment.servers_integrations.CITA.PATH_INTERNAL + environment.servers_integrations.CITA.NAME_FILES.INDEX,
      // tslint:disable-next-line:max-line-length
      dowloadDocument: environment.servers_integrations.CITA.SERVER + environment.servers_integrations.CITA.PATH_DOWNLOAD + environment.servers_integrations.CITA.NAME_FILES.DOWNLOAD_DOC + '?id=',
      // tslint:disable-next-line:max-line-length
      urlGenrationRotulo: environment.servers_integrations.CITA.SERVER + environment.servers_integrations.CITA.PATH_VIEW + environment.servers_integrations.CITA.NAME_FILES.VIEW_STICKER + '?iddocumento=',
      // tslint:disable-next-line:max-line-length
      urlGenrationCaratula: environment.servers_integrations.CITA.SERVER + environment.servers_integrations.CITA.PATH_VIEW + environment.servers_integrations.CITA.NAME_FILES.VIEW_MASK + '?iddocumento=',
      // tslint:disable-next-line: max-line-length
      urlActasMinisterio: environment.servers_integrations.CITA.SERVER + environment.servers_integrations.CITA.PATH_INTERNAL + environment.servers_integrations.CITA.ACTAS_MINISTERIO + environment.servers_integrations.CITA.NAME_FILES.INDEX
    }
  };
  // Contiene los campos internos que no necesitan parametros
  static readonly EXCEPTION_PARAMETERS_FIELD_INTERNAL = [
    'tarea-fecha-activacion',
    'tarea-fecha-finalizacion',
    'tarea-responsables'
  ];
  // Contiene la lista de parametros de los diferentes parametros de los campos internos para reportes
  static readonly PARAMETERS_FIELD_INTERNAL = {
    'general': [
      {key: 'nombre', value: 'Nombre'},
      {key: 'descripcion', value: 'Descripción'}
    ],
    'tramite-expediente': [
      {key: 'codigo', value: 'Código'},
      {key: 'fecha_registro', value: 'Fecha radicado expediente'},
      {key: 'id_expediente_cita', value: 'Id expediente en CITA'},
      {key: 'fecha_creacion', value: 'Fecha creación del expediente'},
    ],
    'actividad': [
      {key: 'nombre', value: 'Nombre'},
      {key: 'descripcion', value: 'Descripción'},
      {key: 'orden', value: 'Orden'},
    ]
  };
  // Funciones de los documentos
  static readonly DOCUMENTS_FUNCTIONS = {
    upload: 'Subir',
    dowload: 'Descargar',
    generate: 'Generar',
    sign: 'Firmar',
    radication : 'Radicar',
    approve: 'Aprobar'
  };
  // NOTA: Pendiente organizar los nombres de las constantes apartir de esta nota ya que deben ser en mayuscula
  // Modulos o typos de permisos en el sistema
  static readonly types_permissions = {
    administrationProcess: 'administracion_procesos',
    administrationUtilities: 'administracion_utilitarios',
    administrationHoliDays: 'administracion_dias_especiales',
    administrationMasterTables: 'administracion_maestras',
    administrationGroupsPermissions: 'administracion_grupos_permisos',
    reportsInstance: 'reportes_instacia',
    instanceProcess: 'gestion_procesos',
    administrationDocument: 'administracion_documentos',
    administrationSystem: 'Administraciones_sistema'
  };
  // tipos de acciones en los permisos
  static readonly types_action_permissions = {
    created: 'crear',
    review: 'ver',
    update: 'modificar',
    delete: 'eliminar',
    initProcess: 'iniciar_proceso',
    generateReport: 'generar_reporte',
    duplicate: 'duplicar',
    createUserSystem: 'crear_usuarios_sistema',
    reviewUserSystem: 'ver_usuarios_sistema',
    updateUserSystem: 'modificar_usuarios_sistema',
    deleteUserSystem: 'eliminar_usuarios_sistema',
    buildStructure: 'construir_estructura_maestra',
    reviewStructure: 'ver_estructura_maestra',
    deleteStructure: 'eliminar_estructura_maestra',
    buildForms: 'construir_formas',
    dataLoad: 'cargar_datos',
    updateCompany: 'modificar_empresa',
    createSede: 'crear_sede',
    updateSede: 'modificar_sede',
    deleteSede: 'eliminar_sede',
    reviewSede: 'ver_sede',
    reviewSmtp: 'ver_smtp',
    updateSmtp: 'modificar_smtp',
    createSmtp: 'create_smtp'
  };
  // acciones en las vistas dinamicas
  static readonly DYNAMIC_VIEW_ACTIONS = {
    iniciarTramite: 'iniciar_tramite',
    generarReporte: 'generar_reporte',
    iniciarAsignandoResponsables: 'iniciar_asignando_responsables'
  };
  // Nombre maestra municipios
  static readonly NAME_MASTER_TABLE_MUNICIPALITY = 'Municipios';

  //Estados de las etapas general y actual de un tramite
  static readonly STAGESTATUS = {
    upToDay: 'Al día',
    toExpire: 'Por vencerse',
    expired: 'Vencido'
  };

}



// WEBPACK FOOTER //
// ./src/app/shared/util/constants.ts